<template>
  <main>
    <!-- Trigger Section -->
    <div>
      <section class="grid gap-4">
        <!-- GST Block -->
        <section v-if="gstInData?.length > 0" class="w-full rounded-lg bg-white">
          <aside v-for="(data, index) in  gstInData" :key="index">
            <article class="flex justify-between items-center py-4 pl-3 pr-6">
              <div class="flex gap-3 items-center">
                <div class="w-7 h-7 ml-3">
                  <Vue3Lottie :animationData="GreenCheckAnimation" :speed="1" :loop="true" />
                </div>
                <span class="grid gap-0.5">
                  <p class="label-text-medium">GSTIN</p>
                  <p class="secondary-heading-text">{{ data.gstn }}</p>
                </span>
              </div>
              <div class="text-successColor font-blogger font-semibold text-xs">
                Verified
              </div>
            </article>
            <hr/>
            <article class="grid gap-2 pt-2 py-4 pl-4 pr-6">
              <div class="grid gap-0.5">
                <p class="secondary-headingColor-text-blogger font-semibold">
                  Business Name
                </p>
                <p class="secondary-heading-text">
                  {{ data.name }}
                </p>
              </div>
              <div class="grid gap-0.5">
                <p class="secondary-headingColor-text-blogger font-semibold">
                  Principal Place of Business
                </p>
                <p class="secondary-heading-text">
                  {{ data.businessAddress }}
                </p>
              </div>
            </article>
          </aside>
        </section>
        <!-- Udyam -->
        <section v-if="udyamData" class="w-full rounded-lg bg-white">
          <article class="flex justify-between items-center py-4 pl-3 pr-6">
            <div class="flex gap-3 items-center">
              <div class="w-7 h-7 ml-3">
                <Vue3Lottie :animationData="GreenCheckAnimation" :speed="1" :loop="true" />
              </div>
              <span class="grid gap-0.5">
                <p class="label-text-medium">Udyam</p>
                <p class="secondary-heading-text">{{ udyamData?.udyamNumber }}</p>
              </span>
            </div>
            <div class="text-successColor font-blogger font-semibold text-xs">
              Verified
            </div>
          </article>
          <hr/>
          <article class="grid gap-2 pt-2 py-4 pl-4 pr-6">
            <div class="grid gap-0.5">
              <p class="secondary-headingColor-text-blogger font-semibold">
                Business Name
              </p>
              <p class="secondary-heading-text">
                {{ udyamData?.officialName }}
              </p>
            </div>
          </article>
        </section>
        <!-- FSSAI -->
        <section v-if="isFssai" class="w-full rounded-lg bg-white">
          <article class="flex justify-between items-center py-4 pl-3 pr-6">
            <div class="flex gap-3 items-center">
              <div class="w-7 h-7 ml-3">
                <Vue3Lottie :animationData="GreenCheckAnimation" :speed="1" :loop="true" />
              </div>
              <span class="grid">
                <p class="label-text-medium">FSSAI</p>
                <p class="secondary-heading-text">uploaded</p>
              </span>
            </div>
            <div class="grid gap-1 text-center">
              <p @click.prevent="reUploadDoc('FSSAI')"
                class="text-primary underline font-blogger text-xs">
                Re-upload
              </p>
            </div>
          </article>
        </section>
        <!-- FDA -->
        <section v-if="isFda" class="w-full rounded-lg bg-white">
          <article class="flex justify-between items-center py-4 pl-3 pr-6">
            <div class="flex gap-3 items-center">
              <div class="w-7 h-7 ml-3">
                <Vue3Lottie :animationData="GreenCheckAnimation" :speed="1" :loop="true" />
              </div>
              <span class="grid">
                <p class="label-text-medium">FDA</p>
                <p class="secondary-heading-text">uploaded</p>
              </span>
            </div>
            <div class="grid gap-1 text-center">
              <p @click.prevent="reUploadDoc('FDA')" class="text-primary underline font-blogger text-xs">Re-upload</p>
            </div>
          </article>
        </section>
        <!-- Shop & Establishment -->
        <section v-if="isShopAndEstablishmentUploaded" class="w-full rounded-lg bg-white">
          <article class="flex justify-between items-center py-4 pl-3 pr-6">
            <div class="flex gap-3 items-center">
              <div class="w-7 h-7 ml-3">
                <Vue3Lottie :animationData="GreenCheckAnimation" :speed="1" :loop="true" />
              </div>
              <span class="grid">
                <p class="label-text-medium whitespace-nowrap truncate w-28">Shop & Establishment</p>
                <p class="secondary-heading-text">uploaded</p>
              </span>
            </div>
            <div class="grid gap-1 text-center">
              <p @click.prevent="reUploadDoc('Shop & Establishment')" class="text-primary underline font-blogger text-xs">Re-upload</p>
            </div>
          </article>
        </section>
        <!-- Others -->
        <section v-if="isOther" class="w-full rounded-lg bg-white">
          <article class="flex justify-between items-center py-4 pl-3 pr-6">
            <div class="flex gap-3 items-center">
              <div class="w-7 h-7 ml-3">
                <Vue3Lottie :animationData="GreenCheckAnimation" :speed="1" :loop="true" />
              </div>
              <span class="grid">
                <p class="label-text-medium">Others</p>
                <p class="secondary-heading-text">uploaded</p>
              </span>
            </div>
            <div class="grid gap-1 text-center">
              <p @click.prevent="reUploadDoc('Others')" class="text-primary underline font-blogger text-xs">Re-upload</p>
            </div>
          </article>
        </section>
        <!-- Video Kyc -->
        <section v-if="videoKycScheduledDateTime" class="w-full rounded-lg bg-white">
          <article class="flex justify-between items-center py-4 pl-3 pr-6">
            <div class="flex gap-3 items-center">
              <div class="w-7 h-7 ml-3">
                <Vue3Lottie :animationData="GreenCheckAnimation" :speed="1" :loop="true" />
              </div>
              <span class="grid gap-0.5">
                <p class="label-text-medium">Video KYC</p>
              </span>
            </div>
            <div class="text-successColor font-blogger font-semibold text-xs">
              Scheduled
            </div>
          </article>
          <hr/>
          <article class="grid gap-2 pt-2 py-4 pl-4 pr-6">
            <div class="flex justify-between gap-0.5">
              <span>
                <p class="secondary-headingColor-text-blogger font-semibold">
                  Select Date
                </p>
                <p class="secondary-heading-text">
                  {{ videoKycScheduledDateTime?.date }}
                </p>
              </span>
              <span @click.prevent="toggleModal('skipUploadSelection')">
                <p class="secondary-headingColor-text-blogger font-semibold text-primary underline cursor-pointer">
                  Change
                </p>
              </span>
            </div>
             <div class="grid gap-0.5">
              <p class="secondary-headingColor-text-blogger font-semibold">
                Select Time
              </p>
              <p class="secondary-heading-text">
                {{ videoKycScheduledDateTime?.time }}
              </p>
            </div>
          </article>
        </section>
        <!-- One More and Skip Upload -->
        <section v-if="!isTwoOrMore" class="grid gap-3">
          <p class="label-text-medium">Just One More Step</p>
          <section class="shadow-cardShadow w-full rounded-lg bg-white">
            <div @click.prevent="toggleModal('documentSelection')" class="flex justify-between gap-4 items-center px-3 py-4">
              <aside>
                <transition name="out-in">
                  <article class="flex gap-2">
                    <div class="flex gap-3">
                      <img src="../assets/doc.svg" alt="" class="h-10">
                      <span class="grid gap-0.5">
                        <p class="label-text-medium">One More Document to Go</p>
                        <p class="secondary-heading-text">Udyam, FSSAI, or Shop & Establishment certificate</p>
                      </span>
                    </div>
                  </article>
                </transition>
              </aside>
            </div>
          </section>
          <span v-if="!(videoKycScheduledDateTime?.date && videoKycScheduledDateTime?.time)" class="secondary-headingColor-text text-center">
            OR
          </span>
          <section v-if="!(videoKycScheduledDateTime?.date && videoKycScheduledDateTime?.time)" @click.prevent="toggleModal('skipUploadSelection')" class="shadow-cardShadow w-full rounded-lg bg-white">
            <div class="flex justify-between gap-4 items-center px-3 py-4">
              <aside>
                <transition name="out-in">
                  <article class="flex gap-2">
                    <div class="flex gap-3">
                      <img src="../assets/kyc.svg" alt="" class="h-10">
                      <span class="grid gap-0.5">
                        <p class="label-text-medium">Skip Upload, Choose Video KYC</p>
                        <p class="secondary-heading-text">No second document? Verify via 3–5 min Video KYC.</p>
                      </span>
                    </div>
                  </article>
                </transition>
              </aside>
            </div>
          </section>
        </section>
      </section>
    </div>
    <router-view>
      <sidebar
        :isPanelOpen="isPanelOpen"
        @closeSidebarPanel="closeSideBar()"
        position="bottom"
        paddingTopBottom="paddingTopBottomHide"
        :panelHeight="customPanelHeight"
      >
        <section v-if="documentSelection">
          <business-documents-list
            :documentsProps="documentTypes"
            @close-sidebar="closeSideBar"
          />
        </section>
        <section v-if="skipUploadSelection">
          <div
            class="grid justify-center text-center gap-4 border-gray-200 px-4 py-2 mb-4 pt-4"
          >
            <div @click.prevent="closeSideBar()" title="Close Sidebar" class="h-1 w-40 bg-textSecondary rounded-full grid justify-self-center"></div>
            <h2 class="heading-text">Schedule Your Video KYC</h2>
          </div>
          <div class="grid justify-items-center gap-4">
            <img class="h-28" src="../assets/v-kyc-icon.svg" alt="v kyc">
            <p class="text-center label-text-myriad">Please choose a suitable date and time for your video KYC verification. Our agent will contact you accordingly.</p>
          </div>
          <form class="grid mx-4 pt-5 gap-4" @submit.prevent="submitVideoKyc()">
            <!-- Date -->
            <custom-dropdown
              v-model="params.dob"
              :options="dateOptions"
              placeholder="Select Date"
              :required="true"
            />
            <!-- Time -->
            <custom-dropdown
              v-model="params.time"
              :options="timeOptions"
              placeholder="Select Time"
              :icon="require('@/assets/time-icon.svg')"
              :required="true"
              :disabled="!params.dob || isSpinLoading"
            />
            <div class="flex gap-4 pt-10 pb-8">
              <custom-button
                variant="transparentPrimary"
                @click.prevent="closeSideBar"
                class="w-full"
              >
                Cancel
              </custom-button>
              <custom-button
                :variant="params.dob && params.time ? 'primary' : 'disableGray'"
                type="submit"
                class="w-full"
                :disabled="!(params.dob && params.time)"
              >
                Confirm
              </custom-button>
            </div>
          </form>
        </section>
      </sidebar>
    </router-view>
  <!-- Spin Loader -->
  <spin-loader :spinLoading="isSpinLoading"/>
  </main>
</template>

<script>
import { mapGetters } from 'vuex';
import Sidebar from '../components/Sidebar.vue';
import SpinLoader from '../components/spinLoader.vue';
import CustomButton from '../components/CustomButton.vue';
import CustomDropdown from "../components/CustomDropdown.vue";
import GreenCheckAnimation from '../assets/animation/green_check_animation.json';
import BusinessDocumentsList from '../components/BusinessDocumentsList.vue';

  export default {
    name: "BusinessRegisterationProofUpload",
    components: {
      Sidebar,
      SpinLoader,
      CustomButton,
      CustomDropdown,
      BusinessDocumentsList
    },
    data() {
      return {
        isPanelOpen: undefined,
        customPanelHeight: 'auto',
        GreenCheckAnimation,
        documentName: undefined,
        isSpinLoading: false,
        uploadedDocuments: undefined,
        selectedImage: null,
        isPopupVisible: false,
        documentSelection: false,
        skipUploadSelection: false,
        scheduleDataTime: undefined,
        udyamData: undefined,
        isFssai: false,
        isFda: false,
        isShopAndEstablishmentUploaded: false,
        isOther: false,
        gstInData: [],
        documentTypes: [],
        params: {
          dob: undefined,
          time: undefined
        },
        popUpMessage: {
          message1: '• Take a photo of the business document clearly visible'
        },
      };
    },
    computed: {
      ...mapGetters([
        'videoKycScheduledDateTime',
        'applicationProfileData',
        'applicationSummary',
        'applicationId',
        'gstDataQuery',
        'udyamDataPass',
        'fssaiDataPass',
        'fdaDataPass',
        'shopAndEstablishmentDataPass',
        'otherDataPass'
      ]),
      dateOptions() {
        return this.scheduleDataTime ? Object.keys(this.scheduleDataTime) : [];
      },
      timeOptions() {
        return this.params.dob && this.scheduleDataTime
          ? this.scheduleDataTime[this.params.dob]
          : [];
      },
      isTwoOrMore() {
        const count = [
          this.gstInData?.length > 0,
          Object.keys(this.udyamData || {}).length > 0,
          this.isFssai,
          this.isOther,
          this.isShopAndEstablishmentUploaded,
          this.isFda,
          this.videoKycScheduledDateTime
        ].filter(Boolean).length;
        if (count >= 2) {
          this.$store.commit('SET_IS_BUSINESS_REGISTRATION_DOC_UPLOADED', true);
        } else {
          this.$store.commit('SET_IS_BUSINESS_REGISTRATION_DOC_UPLOADED', false);
        }
        return count >= 2;
      },
    },
    mounted() {
      this.init();
    },
    watch: {
      'params.dob': function newDate() {
        this.params.time = "";
      },
      fssaiDataPass() {
        this.setData();
      },
      fdaDataPass() {
        this.setData();
      },
      shopAndEstablishmentDataPass() {
        this.setData();
      },
      otherDataPass() {
        this.setData();
      }
    },
    methods: {
      init() {
        if (!this.applicationProfileData) {
          this.getApplicationProfile();
        }
        this.setData();
        this.applicationProfileLoaded();
      },
      getApplicationProfile() {
        this.isSpinLoading = true;
        this.$store
          .dispatch('applicationProfile', {
            applicationId: this.applicationId
          })
          .then(() => {
            this.isSpinLoading = false;
          })
          .catch(() => {
            this.isSpinLoading = false;
          });
      },
      previewFile(data) {
        this.selectedImage = data;
        this.$router.push({
          name: 'Preview Statements',
          params: {
            name: 'Business Document',
            id: data.id,
            contentType: data.contentType,
            docName: data.name || 'business document',
          },
        });
      },
      toggleModal(selection) {
        if (selection === 'documentSelection') {
          this.documentSelection = true;
        } else {
          this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_VKYC_CLICKED, {
            [this.$mixpanelPayload.KEY_MESSAGE]: 'text on btn:- Skip Upload, Choose Video KYC',
          });
          this.skipUploadSelection = true;
          this.getAvailableSlots();
        }
        this.isPanelOpen = true;
      },
      closeSideBar() {
        this.isPanelOpen = false;
        this.documentSelection = false;
        this.skipUploadSelection = false;
        this.params.dob = undefined;
        this.params.time = undefined;
      },
      getAvailableSlots() {
        this.isSpinLoading = true;
        this.$store
          .dispatch('availableSlots')
          .then((result) => {
            this.scheduleDataTime = result;
            this.isSpinLoading = false;
          })
          .catch(() => {
            this.isSpinLoading = false;
          });
      },
      submitVideoKyc() {
        this.isSpinLoading = true;
          const dateTime = {
            date: this.params.dob,
            time: this.params.time
          };
          this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_VKYC_SLOT_SCHEDULED, {
            [this.$mixpanelPayload.KEY_MESSAGE]: dateTime,
          });
          this.$store.commit('SET_VIDEO_KYC_SCHEDULED_DATE_TIME',
            {
              date: dateTime.date,
              time: dateTime.time
            },
          );
          this.closeSideBar();
          this.isSpinLoading = false;
      },
      setData() {
        localStorage.setItem('isBusinessBlock', true);
        this.isSpinLoading = true;
        const summaryBusinessInfo = this.applicationSummary?.businessInfo;
        const summaryDocumentList = this.applicationSummary?.documentListUploaded;
        if (this.gstDataQuery?.length > 0) {
          this.gstInData = this.gstDataQuery;
          this.isSpinLoading = false;
        } else if (summaryBusinessInfo.gstin) {
          const gstn = [
            {
              gstn: summaryBusinessInfo?.gstin,
              name: summaryBusinessInfo?.name,
              businessAddress: [
                  summaryBusinessInfo?.address?.line1,
                  summaryBusinessInfo?.address?.city,
                  summaryBusinessInfo?.address?.state,
                  summaryBusinessInfo?.address?.pincode
                ].filter(Boolean).join(', ')
            }
          ];
          this.gstInData = gstn;
        }
        if (this.udyamDataPass) {
          this.udyamData = this.udyamDataPass;
        } else {
          this.udyamData = summaryBusinessInfo.udyamDetails;
        }
        if (this.fssaiDataPass) {
          this.isFssai = this.fssaiDataPass;
        } else {
          this.isFssai = summaryDocumentList?.fssaiUploaded;
        }
        if (this.fdaDataPass) {
          this.isFda = this.fdaDataPass;
        } else {
          this.isFda = summaryDocumentList?.fdaUploaded;
        }
        if (this.shopAndEstablishmentDataPass) {
          this.isShopAndEstablishmentUploaded = this.shopAndEstablishmentDataPass;
        } else {
          this.isShopAndEstablishmentUploaded = summaryDocumentList?.shopAndEstablishmentUploaded;
        }
        if (this.otherDataPass) {
          this.isOther = this.otherDataPass;
        } else {
          this.isOther = this.applicationSummary?.documentListUploaded?.othersUploaded;
        }
        this.isSpinLoading = false;
      },
      applicationProfileLoaded() {
        const businessRegistrationProofs = this.applicationProfileData?.documents?.filter(
          (document) => document.docType === 'business_registration_proof'
        ) || undefined;
        if (businessRegistrationProofs?.length > 0) {
          this.$store.commit('SET_IS_BUSINESS_REGISTRATION_DOC_UPLOADED', true);
        }
        if (businessRegistrationProofs?.length > 0) {
          this.$store.commit('SET_IS_BUSINESS_REGISTRATION_DOC_UPLOADED', true);
        }
        this.uploadedDocuments = businessRegistrationProofs;
      },
      reUploadDoc(val) {
        this.$emit('business-document-select', val);
      }
  }
};
</script>

<style lang="scss" scoped>
/* Hide the default dropdown arrow in all browsers */
select {
  -webkit-appearance: none; /* Safari, Chrome */
  -moz-appearance: none; /* Firefox */
  appearance: none; /* Modern browsers */
  background-image: none; /* Remove native arrow in some cases */
}
label {
  cursor: pointer;
  z-index: 5;
}
</style>
